import React from "react";
import styled from "styled-components";
import Tag from "../Tag/Tag";
import Button from "../Button/Button";

export default class Item extends React.Component {
  constructor(props) {
    super(props);
    this.data = props.data;

    this.name = this.data.name;
    this.type = this.data.type;
    this.media = this.data.media;
    this.metadata = this.data.metadata;
  }
  render() {
    return (
      <Component valign={this.props.valign} compact={this.props.compact}>
        <div>
          <b>{this.name}</b>
          {this.media !== undefined ? (
            <Thumbnail>
              {this.media.platform === "custom_picture" ? (
                <div
                  className="responsive-container"
                  style={{ background: this.media.color, textAlign: "center" }}
                >
                  <img
                    src={this.media.id}
                    style={{ height: "100%", width: "auto" }}
                  />
                </div>
              ) : (
                false
              )}
              {this.media.platform === "youtube" ? (
                <div className="responsive-container">
                  <iframe
                    width="560"
                    height="315"
                    src={"https://www.youtube.com/embed/" + this.media.id}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullscreen
                  />
                </div>
              ) : (
                false
              )}
              {this.media.platform === "soundcloud" ? (
                <iframe
                  width="100%"
                  height="166"
                  scrolling="no"
                  frameBorder="no"
                  src={
                    "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/" +
                    this.media.id +
                    "&amp;color=ff5500"
                  }
                />
              ) : (
                false
              )}
              {this.media.platform === "nytimes" ? (
                <div className="responsive-container">
                  <iframe
                    title="New York Times Video - Embed Player"
                    width="480"
                    height="321"
                    frameBorder="0"
                    scrolling="no"
                    allowFullscreen="true"
                    marginHeight="0"
                    marginWidth="0"
                    id="nyt_video_player"
                    src={
                      "https://static01.nyt.com/video/players/offsite/index.html?videoId=" +
                      this.media.id
                    }
                  />
                </div>
              ) : (
                false
              )}
              {this.media.platform === "podcasts.ox.ac.uk" ? (
                <div className="responsive-container">
                  <iframe
                    width="640"
                    height="130"
                    src={"https://podcasts.ox.ac.uk/embed/" + this.media.id}
                    frameBorder="0"
                    allowFullscreen
                  />
                </div>
              ) : (
                false
              )}
              {this.media.platform === "ted" ? (
                <div style={{ maxWidth: "854px" }}>
                  <div
                    style={{
                      position: "relative",
                      height: 0,
                      paddingBottom: "56.25%"
                    }}
                  >
                    <iframe
                      src={"https://embed.ted.com/talks/" + this.media.id}
                      width="854"
                      height="480"
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%"
                      }}
                      frameBorder="0"
                      scrolling="no"
                      allowFullscreen
                    />
                  </div>
                </div>
              ) : (
                false
              )}
              {this.media.platform === "vimeo" ? (
                <div className="responsive-container">
                  <iframe
                    title={this.name}
                    src={"https://player.vimeo.com/video/" + this.media.id}
                    width="640"
                    height="360"
                    frameBorder="0"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowFullscreen
                  />
                </div>
              ) : (
                false
              )}
              {this.media.platform === "audio_html" ? (
                <audio controls>
                  <source
                    src="https://dts.podtrac.com/redirect.mp3/dovetail.prxu.org/59/1e0592e7-4a24-4627-a73f-a4e95ca8007b/EH_ep4_billboard.mp3"
                    type="audio/mpeg"
                  />
                  Your browser does not support the audio element
                </audio>
              ) : (
                false
              )}
            </Thumbnail>
          ) : (
            ""
          )}
        </div>
        <div className="actions">
          {!this.props.compact
            ? Object.keys(this.metadata).map((property, i) => (
                <dl key={i} className={"property-" + property}>
                  <dt>{property}</dt>
                  <dd>
                    {property === "Source Link" || property === "Website" ? (
                      <a href={this.metadata[property]} target="_blank">
                        {this.metadata[property]}
                      </a>
                    ) : (
                      <span>{this.metadata[property]}</span>
                    )}
                  </dd>
                </dl>
              ))
            : ""}
          <Tag type={this.type.color}>{this.type.name}</Tag>
          <Button
            onClick={
              this.props.clickOnViewButton
                ? () => this.props.clickOnViewButton(this.props.project)
                : false
            }
            size="xs"
          >
            View
          </Button>
        </div>
      </Component>
    );
  }
}

const Component = styled.div`
  position: relative;
  height: ${props => (props.compact ? false : "100%")};
  display: flex;
  flex-direction: ${props => (props.compact ? "row" : "column")};
  justify-content: ${props =>
    props.valign === "top" ? "flex-start" : "space-between"};
  align-items: flex-start;
  width: 100%;
  border-bottom: ${props => (props.compact ? "1px solid #eaeaea" : false)};
  padding: ${props => (props.compact ? "8px 0" : false)};

  img {
    max-width: 100%;
  }

  b {
    font-family: "Roboto Slab";
    font-weight: 400;
  }

  & > div {
    width: 100%;
  }

  dl {
    font-size: 11px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  dt {
    font-size: 0.9em;
    letter-spacing: 0.1em;
    margin-bottom: 3px;
    color: grey;
  }

  dd {
    margin-left: 0;
    display: flex;
  }

  .flag {
    position: relative;
    top: 3px;
  }

  .actions {
    display: ${props => (props.compact ? "flex" : false)}
    width: ${props => (props.compact ? "100px" : false)};
    margin-left: ${props => (props.compact ? "15px" : false)};
  }

  button {
    position: ${props => (props.compact ? false : "absolute")};
    right: 0;
    bottom: 0;
    margin-left: 8px;
  }

  ${Tag} {
    max-width: calc(100% - 48px);
  }

  audio {
    width: 100%;
  }

  iframe {
    max-width: 100%;
    height: auto;
    margin: 16px 0;
  }

  a {
    display: inline-block;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Thumbnail = styled.div`
  margin: 15px -15px;
  width: calc(100% + 30px);

  iframe {
    margin: 0;
    width: 100%;
    background: #ccc;
  }

  & > div {
    border-bottom: 1px solid #eaeaea;
  }

  .responsive-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    height: auto;
  }
  .responsive-container iframe,
  .responsive-container object,
  .responsive-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .responsive-container img {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/UI/Item/Item.js